import * as firebase from 'firebase/app';
import API from '@/api';
import 'firebase/storage';
import Configuration from '@/utils/configuration';

const ASSETS_HOST = Configuration.value('VUE_APP_ASSETS_HOST');

const GET_CLUBHOUSES = 'GET_CLUBHOUSES';
const GET_CLUBHOUSES_SUCCESS = 'GET_CLUBHOUSES_SUCCESS';
const GET_CLUBHOUSES_FAILED = 'GET_CLUBHOUSES_FAILED';

const GET_CLUBHOUSE = 'GET_CLUBHOUSE';
const GET_CLUBHOUSE_SUCCESS = 'GET_CLUBHOUSE_SUCCESS';
const GET_CLUBHOUSE_FAILED = 'GET_CLUBHOUSE_FAILED';

const RESET_CLUBHOUSE = 'RESET_CLUBHOUSE';

const UPDATE_CLUBHOUSE = 'UPDATE_CLUBHOUSE';
const UPDATE_CLUBHOUSE_SUCCESS = 'UPDATE_CLUBHOUSE_SUCCESS';
const UPDATE_CLUBHOUSE_FAILED = 'UPDATE_CLUBHOUSE_FAILED';
const UPDATE_CLUBHOUSE_HOURS = 'UPDATE_CLUBHOUSE_HOURS';
const UPDATE_CLUBHOUSE_COORDS = 'UPDATE_CLUBHOUSE_COORDS';

const DELETE_CLUBHOUSE = 'DELETE_CLUBHOUSE';
const DELETE_CLUBHOUSE_SUCCESS = 'DELETE_CLUBHOUSE_SUCCESS';
const DELETE_CLUBHOUSE_FAILED = 'DELETE_CLUBHOUSE_FAILED';

const SET_HANDICAP = 'SET_HANDICAP';
const SET_HANDICAP_SUCCESS = 'SET_HANDICAP_SUCCESS';
const SET_HANDICAP_FAILED = 'SET_HANDICAP_FAILED';

const GET_CLUBHOUSE_CARD = 'GET_CLUBHOUSE_CARD';
const GET_CLUBHOUSE_CARD_SUCCESS = 'GET_CLUBHOUSE_CARD_SUCCESS';
const GET_CLUBHOUSE_CARD_FAILED = 'GET_CLUBHOUSE_CARD_FAILED';

const GET_CLUBHOUSE_CARDS = 'GET_CLUBHOUSE_CARDS';
const GET_CLUBHOUSE_CARDS_SUCCESS = 'GET_CLUBHOUSE_CARDS_SUCCESS';
const GET_CLUBHOUSE_CARDS_FAILED = 'GET_CLUBHOUSE_CARDS_FAILED';

const GET_USER_CLUBHOUSE_CARDS = 'GET_USER_CLUBHOUSE_CARDS';
const GET_USER_CLUBHOUSE_CARDS_SUCCESS = 'GET_USER_CLUBHOUSE_CARDS_SUCCESS';
const GET_USER_CLUBHOUSE_CARDS_FAILED = 'GET_USER_CLUBHOUSE_CARDS_FAILED';

const CREATE_CLUBHOUSE_CARD = 'CREATE_CLUBHOUSE_CARD';
const CREATE_CLUBHOUSE_CARD_SUCCESS = 'CREATE_CLUBHOUSE_CARD_SUCCESS';
const CREATE_CLUBHOUSE_CARD_FAILED = 'CREATE_CLUBHOUSE_CARD_FAILED';

const UPDATE_CLUBHOUSE_CARD = 'UPDATE_CLUBHOUSE_CARD';
const UPDATE_CLUBHOUSE_CARD_SUCCESS = 'UPDATE_CLUBHOUSE_CARD_SUCCESS';
const UPDATE_CLUBHOUSE_CARD_FAILED = 'UPDATE_CLUBHOUSE_CARD_FAILED';

const DELETE_CLUBHOUSE_CARD = 'DELETE_CLUBHOUSE_CARD';
const DELETE_CLUBHOUSE_CARD_SUCCESS = 'DELETE_CLUBHOUSE_CARD_SUCCESS';
const DELETE_CLUBHOUSE_CARD_FAILED = 'DELETE_CLUBHOUSE_CARD_FAILED';

const DELETE_CLUBHOUSE_IMAGE = 'DELETE_CLUBHOUSE_IMAGE';
const DELETE_CLUBHOUSE_IMAGE_SUCCESS = 'DELETE_CLUBHOUSE_IMAGE_SUCCESS';
const DELETE_CLUBHOUSE_IMAGE_FAILED = 'DELETE_CLUBHOUSE_IMAGE_FAILED';

const RESET_CARD = 'RESET_CARD';
const SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS';

const GET_MEMBERS = 'GET_MEMBERS';
const GET_MEMBERS_SUCCESS = 'GET_MEMBERS_SUCCESS';
const GET_MEMBERS_FAILED = 'GET_MEMBERS_FAILED';

const GET_DATA = 'GET_DATA';
const GET_DATA_FAILED = 'GET_DATA_FAILED';
const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';

const GET_MEMBER_CLUBS = 'GET_MEMBER_CLUBS';
const GET_MEMBER_CLUBS_FAILED = 'GET_MEMBER_CLUBS_FAILED';
const GET_MEMBER_CLUBS_SUCCESS = 'GET_MEMBER_CLUBS_SUCCESS';

const UPDATE_CLUBMEMBER = 'UPDATE_CLUBMEMBER';
const UPDATE_CLUBMEMBER_FAILED = 'UPDATE_CLUBMEMBER_FAILED';
const UPDATE_CLUBMEMBER_SUCCESS = 'UPDATE_CLUBMEMBER_SUCCESS';

const DELETE_MEMBER = 'DELETE_MEMBER';
const DELETE_MEMBER_SUCCESS = 'DELETE_MEMBER_SUCCESS';
const DELETE_MEMBER_FAILED = 'DELETE_MEMBER_FAILED';

const GET_ALL_LICENSES = 'GET_ALL_LICENSES';
const GET_ALL_LICENSES_SUCCESS = 'GET_ALL_LICENSES_SUCCESS';
const GET_ALL_LICENSES_FAILED = 'GET_ALL_LICENSES_FAILED';

const GET_LICENSES = 'GET_LICENSES';
const GET_LICENSES_SUCCESS = 'GET_LICENSES_SUCCESS';
const GET_LICENSES_FAILED = 'GET_LICENSES_FAILED';

const ADD_CLUB_LICENSE = 'ADD_CLUB_LICENSE';
const ADD_CLUB_LICENSE_SUCCESS = 'ADD_CLUB_LICENSE_SUCCESS';
const ADD_CLUB_LICENSE_FAILED = 'ADD_CLUB_LICENSE_FAILED';

const DELETE_LICENSE = 'DELETE_LICENSE';
const DELETE_LICENSE_SUCCESS = 'DELETE_LICENSE_SUCCESS';
const DELETE_LICENSE_FAILED = 'DELETE_LICENSE_FAILED';

const SET_CLUB_ADDRESS = 'SET_CLUB_ADDRESS';

const GET_CLUB_USER_STATS = 'GET_CLUB_USER_STATS';
const GET_CLUB_USER_STATS_SUCCESS = 'GET_CLUB_USER_STATS_SUCCESS';
const GET_CLUB_USER_STATS_FAILED = 'GET_CLUB_USER_STATS_FAILED';

const GET_CLUB_TOP_USERS = 'GET_CLUB_TOP_USERS';
const GET_CLUB_TOP_USERS_SUCCESS = 'GET_CLUB_TOP_USERS_SUCCESS';
const GET_CLUB_TOP_USERS_FAILED = 'GET_CLUB_TOP_USERS_FAILED';

const GET_CLUB_SHOT_STATS = 'GET_CLUB_SHOT_STATS';
const GET_CLUB_SHOT_STATS_SUCCESS = 'GET_CLUB_SHOT_STATS_SUCCESS';
const GET_CLUB_SHOT_STATS_FAILED = 'GET_CLUB_SHOT_STATS_FAILED';

const GET_CLUB_COURSE_STATS = 'GET_CLUB_COURSE_STATS';
const GET_CLUB_COURSE_STATS_SUCCESS = 'GET_CLUB_COURSE_STATS_SUCCESS';
const GET_CLUB_COURSE_STATS_FAILED = 'GET_CLUB_COURSE_STATS_FAILED';

const GET_CLUB_FAVORITES = 'GET_CLUB_FAVORITES';
const GET_CLUB_FAVORITES_FAILED = 'GET_CLUB_FAVORITES_FAILED';
const GET_CLUB_FAVORITES_SUCCESS = 'GET_CLUB_FAVORITES_SUCCESS';

const GET_CLUB_EVENTS = 'GET_CLUB_EVENTS';
const GET_CLUB_EVENTS_FAILED = 'GET_CLUB_EVENTS_FAILED';
const GET_CLUB_EVENTS_SUCCESS = 'GET_CLUB_EVENTS_SUCCESS';

const GET_CLUB_EVENT_USERS = 'GET_CLUB_EVENT_USERS';
const GET_CLUB_EVENT_USERS_FAILED = 'GET_CLUB_EVENT_USERS_FAILED';
const GET_CLUB_EVENT_USERS_SUCCESS = 'GET_CLUB_EVENT_USERS_SUCCESS';

const GET_CLUB_GAME_MODES = 'GET_CLUB_GAME_MODES';
const GET_CLUB_GAME_MODES_FAILED = 'GET_CLUB_GAME_MODES_FAILED';
const GET_CLUB_GAME_MODES_SUCCESS = 'GET_CLUB_GAME_MODES_SUCCESS';

const GET_CLUB_ROUNDS = 'GET_CLUB_ROUNDS';
const GET_CLUB_ROUNDS_FAILED = 'GET_CLUB_ROUNDS_FAILED';
const GET_CLUB_ROUNDS_SUCCESS = 'GET_CLUB_ROUNDS_SUCCESS';

const GET_CLUB_USAGE_STATS = 'GET_CLUB_USAGE_STATS';
const GET_CLUB_USAGE_STATS_FAILED = 'GET_CLUB_USAGE_STATS_FAILED';
const GET_CLUB_USAGE_STATS_SUCCESS = 'GET_CLUB_USAGE_STATS_SUCCESS';

const GET_CLUB_SIM_USERS = 'GET_CLUB_SIM_USERS';
const GET_CLUB_SIM_USERS_FAILED = 'GET_CLUB_SIM_USERS_FAILED';
const GET_CLUB_SIM_USERS_SUCCESS = 'GET_CLUB_SIM_USERS_SUCCESS';

const GET_CLUB_SIM_TOP_USERS = 'GET_CLUB_SIM_TOP_USERS';
const GET_CLUB_SIM_TOP_USERS_FAILED = 'GET_CLUB_SIM_TOP_USERS_FAILED';
const GET_CLUB_SIM_TOP_USERS_SUCCESS = 'GET_CLUB_SIM_TOP_USERS_SUCCESS';

const GET_CLUB_SIM_COURSES = 'GET_CLUB_SIM_COURSES';
const GET_CLUB_SIM_COURSES_FAILED = 'GET_CLUB_SIM_COURSES_FAILED';
const GET_CLUB_SIM_COURSES_SUCCESS = 'GET_CLUB_SIM_COURSES_SUCCESS';

const GET_CLUB_SIM_SHOTS = 'GET_CLUB_SIM_SHOTS';
const GET_CLUB_SIM_SHOTS_FAILED = 'GET_CLUB_SIM_SHOTS_FAILED';
const GET_CLUB_SIM_SHOTS_SUCCESS = 'GET_CLUB_SIM_SHOTS_SUCCESS';

const GET_CLUB_SIM_FAVORITES = 'GET_CLUB_SIM_FAVORITES';
const GET_CLUB_SIM_FAVORITES_FAILED = 'GET_CLUB_SIM_FAVORITES_FAILED';
const GET_CLUB_SIM_FAVORITES_SUCCESS = 'GET_CLUB_SIM_FAVORITES_SUCCESS';

const GET_CLUB_SIM_GAME_MODES = 'GET_CLUB_SIM_GAME_MODES';
const GET_CLUB_SIM_GAME_MODES_FAILED = 'GET_CLUB_SIM_GAME_MODES_FAILED';
const GET_CLUB_SIM_GAME_MODES_SUCCESS = 'GET_CLUB_SIM_GAME_MODES_SUCCESS';

const GET_CLUB_SIM_ROUNDS = 'GET_CLUB_SIM_ROUNDS';
const GET_CLUB_SIM_ROUNDS_FAILED = 'GET_CLUB_SIM_ROUNDS_FAILED';
const GET_CLUB_SIM_ROUNDS_SUCCESS = 'GET_CLUB_SIM_ROUNDS_SUCCESS';

const GET_CLUB_SIM_USAGE = 'GET_CLUB_SIM_USAGE';
const GET_CLUB_SIM_USAGE_SUCCESS = 'GET_CLUB_SIM_USAGE_SUCCESS';
const GET_CLUB_SIM_USAGE_FAILED = 'GET_CLUB_SIM_USAGE_FAILED';

const RESET_CLUB_STATS = 'RESET_CLUB_STATS';
const RESET_CLUB_SIM_STATS = 'RESET_CLUB_SIM_STATS';
const RESET_CLUB_LICENSES = 'RESET_CLUB_LICENSES';
const RESET_CLUB_MEMBERS = 'RESET_CLUB_MEMBERS';

// Enabled the module to be namespaced
const namespaced = true;

// Image upload specifics
// const IMAGE_URL_QA = 'https://e6golf-qa-assets.imgix.net/';
// const IMAGE_URL_PROD = 'https://e6golf-assets.imgix.net/';
// const BASE_URL = process.env.VUE_APP_SITE_ENV === 'qa' ? IMAGE_URL_QA : IMAGE_URL_PROD;
// const BASE_URL =
//   process.env.ENVIRONMENT === 'qa' || process.env.NODE_ENV === 'development'
//     ? IMAGE_URL_QA
//     : IMAGE_URL_PROD;
const ANNOUNCEMENT_IMG_DIRECTORY = 'uploads/clubhouses/announcements/';
const BRANDING_IMG_DIRECTORY = 'uploads/clubhouses/branding/';
let imageUrl = '';
let headerImageUrl = '';
let logoImageUrl = '';
let key;

const firebaseImageUpload = (response, payload, type, image) => {
  key = `${response.data.clubHouseID ? response.data.clubHouseID : ''}${response.data.id}`;

  if (image.file) {
    const folder = response.data.clubHouseID ? response.data.clubHouseID : response.data.id;
    const imageName = image.file.name.split(' ').join('-');
    const filename = imageName.substr(0, imageName.indexOf('.'));
    const ext = imageName.slice(imageName.lastIndexOf('.'));
    const fileDir = `${type === 'branding' ? BRANDING_IMG_DIRECTORY : ANNOUNCEMENT_IMG_DIRECTORY}`;

    let storageRef = firebase
      .storage()
      .ref(`${fileDir}${folder}/${filename}_${key}${ext}`)
      .put(image.file);
    storageRef
      .then(async (fileData) => {
        if (image.type === 'header') {
          // headerImageUrl = `${BASE_URL}${fileData.metadata.fullPath}`;
          // headerImageUrl = `${process.env.VUE_APP_ASSETS_HOST}${fileData.metadata.fullPath}`;
          headerImageUrl = `${ASSETS_HOST}${fileData.metadata.fullPath}`;
        }
        if (image.type === 'logo') {
          // logoImageUrl = `${BASE_URL}${fileData.metadata.fullPath}`;
          // logoImageUrl = `${process.env.VUE_APP_ASSETS_HOST}${fileData.metadata.fullPath}`;
          logoImageUrl = `${ASSETS_HOST}${fileData.metadata.fullPath}`;
        }

        if (type === 'branding') {
          payload = {
            ...response.data,
            headerUrl: headerImageUrl || response.data.headerUrl,
            logoUrl: logoImageUrl || response.data.logoUrl,
            uuid: response.data.uuid,
          };
          response = await API.clubhouses.update(payload);
        } else {
          // imageUrl = `${BASE_URL}${fileData.metadata.fullPath}`;
          // imageUrl = `${process.env.VUE_APP_ASSETS_HOST}${fileData.metadata.fullPath}`;
          imageUrl = `${ASSETS_HOST}${fileData.metadata.fullPath}`;
          payload = {
            ...response.data,
            imageUrl,
            id: response.data.clubHouseID,
            cardID: response.data.id,
          };
          response = await API.clubhouses.updateCard(payload);
        }
      })
      .catch((error) => {
        storageRef = error;
      });
    return storageRef;
  }
};

// Clubhouse initial state
const state = {
  all: [],
  loading: false,
  loadingLicenses: false,
  loadingAllLicenses: false,
  loadingClubhouse: false,
  loadingGen: false,
  cardsLoading: false,
  clubhouseMembers: [],
  clubmember: {},
  memberClubs: [],
  licenses: [],
  allLicenses: [],
  clubhouse: {},
  coordinates: {},
  handicap: null,
  clubhouseCard: {},
  clubhouseCards: [],
  userClubhouseCards: [],
  userCardsLoading: false,
  uploadProgress: 0,
  clubhouseAddress: '',

  clubhouseUserStats: {},
  clubhouseTopUsers: [],
  clubhouseShotStats: {},
  clubhouseCourseStats: [],
  clubhouseFavorites: {},
  clubhouseEventStats: [],
  clubhouseEventUserStats: [],
  clubhouseGameModeStats: [],
  clubhouseRoundStats: [],
  clubhouseUsageStats: {},

  loadingClubStats: false,
  loadingClubTopUserStats: false,
  loadingClubShotStats: false,
  loadingCourseStats: false,
  loadingClubFavorites: false,
  loadingClubEventStats: false,
  loadingClubEventUserStats: false,
  loadingClubGameModeStats: false,
  loadingClubRoundStats: false,
  loadingClubUsageStats: false,

  clubhouseSimUsers: {},
  clubhouseSimTopUsers: [],
  clubhouseSimShots: {},
  clubhouseSimCourses: [],
  clubhouseSimFavorites: {},
  clubhouseSimGameModes: [],
  clubhouseSimRounds: [],
  clubhouseSimUsage: {},

  loadingClubSimUsers: false,
  loadingClubSimTopUsers: false,
  loadingClubSimShots: false,
  loadingClubSimCourses: false,
  loadingClubSimFavorites: false,
  loadingClubSimGameModes: false,
  loadingClubSimRounds: false,
  loadingClubSimUsage: false,
};

// const emptyState = {
//   all: [],
//   loading: false
// }

// Clubhouse getters
const getters = {
  list: (state) => {
    return state.all ?? [];
  },

  loading: (state) => {
    return state.loading;
  },

  loadingClubhouse: (state) => {
    return state.loadingClubhouse;
  },

  loadingLicenses: (state) => {
    return state.loadingLicenses;
  },

  loadingAllLicenses: (state) => {
    return state.loadingAllLicenses;
  },

  isLoadingGen: (state) => {
    return state.loadingGen;
  },

  getClubhouse: (state) => {
    return { ...state.clubhouse };
  },

  clubhouseMembers: (state) => {
    return state.clubhouseMembers;
  },

  clubhouseMemberCount: (state) => {
    return state?.clubhouseMembers?.length || 0;
  },

  clubmember: (state) => {
    return state.clubmember;
  },

  memberClubs: (state) => {
    return state.memberClubs;
  },

  licenses: (state) => {
    return state.licenses;
  },

  allLicenses: (state) => {
    return state.allLicenses;
  },

  licensesCount: (state) => {
    return state.licenses ? state.licenses.length : 0;
  },

  getCoordinates: (state) => {
    return state.coordinates;
  },

  handicap: (state) => {
    return state.handicap;
  },

  clubhouseCard: (state) => {
    return state.clubhouseCard;
  },

  getClubhouseCards: (state) => {
    return state.clubhouseCards;
  },

  // * Returns all clubhouse cards combined for a user
  getUserClubhouseCards: (state) => {
    return state.userClubhouseCards;
  },

  getUploadProgress: (state) => {
    return state.uploadProgress;
  },

  cardsLoading: (state) => {
    return state.cardsLoading;
  },

  // * loading status of user cards
  userCardsLoading: (state) => {
    return state.userCardsLoading;
  },

  clubhouseAddress: (state) => {
    return state.clubhouseAddress;
  },

  // * Global club stats data
  getClubhouseUserStats: (state) => {
    return state.clubhouseUserStats;
  },

  getClubhouseTopUsers: (state) => {
    return state.clubhouseTopUsers;
  },

  getClubhouseShotStats: (state) => {
    return state.clubhouseShotStats;
  },

  getClubhouseCourseStats: (state) => {
    return state.clubhouseCourseStats;
  },

  getClubhouseFavorites: (state) => {
    return state.clubhouseFavorites;
  },

  getClubhouseEventStats: (state) => {
    return state.clubhouseEventStats;
  },

  getClubhouseEventUserStats: (state) => {
    return state.clubhouseEventUserStats;
  },

  getClubhouseGameModeStats: (state) => {
    return state.clubhouseGameModeStats;
  },

  getClubhouseRoundStats: (state) => {
    return state.clubhouseRoundStats;
  },

  loadingClubStats: (state) => {
    return state.loadingClubStats;
  },

  loadingClubTopUserStats: (state) => {
    return state.loadingClubTopUserStats;
  },

  loadingClubShotStats: (state) => {
    return state.loadingClubShotStats;
  },

  loadingCourseStats: (state) => {
    return state.loadingCourseStats;
  },

  loadingClubFavorites: (state) => {
    return state.loadingClubFavorites;
  },

  loadingClubEventStats: (state) => {
    return state.loadingClubEventStats;
  },

  loadingClubEventUserStats: (state) => {
    return state.loadingClubEventUserStats;
  },

  loadingClubGameModeStats: (state) => {
    return state.loadingClubGameModeStats;
  },

  loadingClubRoundStats: (state) => {
    return state.loadingClubRoundStats;
  },

  // * Per sim club stats data
  getClubhouseSimUsers: (state) => {
    return state.clubhouseSimUsers;
  },

  getClubhouseSimTopUsers: (state) => {
    return state.clubhouseSimTopUsers;
  },

  getClubhouseSimShots: (state) => {
    return state.clubhouseSimShots;
  },

  getClubhouseSimCourses: (state) => {
    return state.clubhouseSimCourses;
  },

  getClubhouseSimFavorites: (state) => {
    return state.clubhouseSimFavorites;
  },

  getClubhouseSimGameModes: (state) => {
    return state.clubhouseSimGameModes;
  },

  getClubhouseSimRounds: (state) => {
    return state.clubhouseSimRounds;
  },

  loadingClubSimUsers: (state) => {
    return state.loadingClubSimUsers;
  },

  loadingClubSimTopUsers: (state) => {
    return state.loadingClubSimTopUsers;
  },

  loadingClubSimShots: (state) => {
    return state.loadingClubSimShots;
  },

  loadingClubSimCourses: (state) => {
    return state.loadingClubSimCourses;
  },

  loadingClubSimFavorites: (state) => {
    return state.loadingClubSimFavorites;
  },

  loadingClubSimGameModes: (state) => {
    return state.loadingClubSimGameModes;
  },

  loadingClubSimRounds: (state) => {
    return state.loadingClubSimRounds;
  },
};

// Clubhouse actions
const actions = {
  // * returns the specified clubhouse
  async show({ commit }, { id, overrideCache = false }) {
    // console.log('show clubhouse===========');
    const defaultHeaderIMG =
      'https://e6golf-assets.imgix.net/uploads/clubhouses/branding/clubhouse-dashboard-header.jpg';
    let response;
    commit(GET_CLUBHOUSE);

    try {
      response = await API.clubhouses.show(id, overrideCache);

      if (!response?.data?.headerUrl) {
        response.data.headerUrl = defaultHeaderIMG;
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_CLUBHOUSE_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUBHOUSE_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  resetClub({ commit }) {
    commit(RESET_CLUBHOUSE);
  },

  // * create a clubhouse
  async create({ commit }, payload) {
    let response;
    commit(GET_CLUBHOUSE);

    try {
      response = await API.admin.createClubhouse(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_CLUBHOUSE_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUBHOUSE_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * updates the clubhouse
  async update({ commit, dispatch }, payload) {
    let response;

    commit(UPDATE_CLUBHOUSE);

    try {
      response = await API.clubhouses.update(payload);
    } catch (error) {
      response = error;
    }

    try {
      const images = [payload.image, payload.logoImage];

      if (images.length && images[0]) {
        for (const [i, image] of images.entries()) {
          if (image.file) {
            firebaseImageUpload(response, payload, 'branding', image).on(
              'state_changed',
              (snapshot) => {
                const progress = Math.floor(
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                commit(SET_UPLOAD_PROGRESS, progress);
              }
            );
            dispatch('deleteImage', images[i]);
          }
        }
      }

      // if (payload.image || payload.logoImage) {
      //   firebaseImageUpload(response, payload, 'branding', images)
      //     .on('state_changed', snapshot => {
      //       let progress = Math.floor(snapshot.bytesTransferred / snapshot.totalBytes * 100)
      //       commit(SET_UPLOAD_PROGRESS, progress)
      //     })
      //   dispatch('deleteImage', payload)
      // }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(UPDATE_CLUBHOUSE_FAILED);
        reject(response);
        return;
      }

      commit(UPDATE_CLUBHOUSE_SUCCESS, response.data);

      dispatch('show', { id: response.data.id, overrideCache: true });
      resolve(response.data);
    });
  },

  // * delete a clubhouse
  async deleteClubhouse({ commit }, uuid) {
    let response;
    commit(DELETE_CLUBHOUSE);

    try {
      response = await API.admin.deleteClubhouse(uuid);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(DELETE_CLUBHOUSE_FAILED);
        reject(response);
        return;
      }

      commit(DELETE_CLUBHOUSE_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * list fetches the clubhouse list from the API
  async list({ commit }, payload) {
    let response = {};

    commit(GET_CLUBHOUSES);

    try {
      response = await API.clubhouses.list(payload);

      if (response?.data) {
        response.data = response.data
          .sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          })
          //* Used to remove this specific clubhouse
          // TODO when private clubhouses are implemented, remove this
          .filter((club) => {
            return club?.uuid !== '3a1029e7-87df-4a9b-a4fc-68b4392ddff8' && club?.id !== 131;
          });
        //* Can just completely remove them from the list. Look into this
        // .filter((club) => {
        //   return club.status === 'public';
        // });
      }
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_CLUBHOUSES_FAILED);
        reject(response);
      } else {
        commit(GET_CLUBHOUSES_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  // * listAdmin fetches the clubhouse list from the API for the admin section
  // TODO Move this to specific admin call
  async listAdmin({ commit }) {
    let response = {};

    commit(GET_CLUBHOUSES);

    try {
      response = await API.clubhouses.list();

      if (response?.data) {
        response.data = response.data.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      }
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_CLUBHOUSES_FAILED);
        reject(response);
      } else {
        commit(GET_CLUBHOUSES_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  // * listMembers fetches the clubhouse member list from the API
  async listMembers({ commit }, id) {
    let response;

    commit(GET_MEMBERS);

    try {
      response = await API.clubhouses.listMembers(id);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_MEMBERS_FAILED);
        reject(response);
      } else {
        commit(GET_MEMBERS_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  // * listMemberClubs fetches the clubhouse list by user uuid
  async listMemberClubs({ commit }, id) {
    let response;

    commit(GET_MEMBER_CLUBS);

    try {
      response = await API.clubhouses.listMemberClubs(id);
      // console.log('response:', response);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_MEMBER_CLUBS_FAILED);
        reject(response);
      } else {
        commit(GET_MEMBER_CLUBS_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  // * deleteMember removes the member from a clubhouse
  async deleteMember({ commit }, payload) {
    let response;

    commit(DELETE_MEMBER);

    try {
      response = await API.clubhouses.deleteMember(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(DELETE_MEMBER_FAILED);
        reject(response);
      } else {
        commit(DELETE_MEMBER_SUCCESS, payload);

        // Return GET data within promise
        resolve(response.data);
      }
    });
  },

  // * addClubmember adds the member to a clubhouse
  async addClubmember({ commit }, payload) {
    let response;

    commit(GET_DATA);

    try {
      response = await API.clubhouses.addClubmember(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, payload);

        // Return GET data within promise
        resolve(response.data);
      }
    });
  },

  // * listLicenses fetches the clubhouse simulator/license list from the API
  async listLicenses({ commit }, id) {
    let response = {};

    commit(GET_LICENSES);

    try {
      response = await API.clubhouses.listLicenses(id);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_LICENSES_FAILED);
        reject(response);
      } else {
        commit(GET_LICENSES_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  // * clublicenses fetches all clubhouse simulator/licenses from the API
  async clublicenses({ commit, getters }, payload) {
    let response = {};

    commit(GET_ALL_LICENSES);

    try {
      response = await API.clubhouses.clublicenses(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ALL_LICENSES_FAILED);
        reject(response);
      } else {
        commit(GET_ALL_LICENSES_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  // * delete removes a license from a clubhouse
  async deleteLicense({ commit }, payload) {
    let response;

    commit(DELETE_LICENSE);

    try {
      response = await API.clubhouses.deleteLicense(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(DELETE_LICENSE_FAILED);
        reject(response);
      } else {
        commit(DELETE_LICENSE_SUCCESS, payload);

        // Return GET data within promise
        resolve(response.data);
      }
    });
  },

  // * Add a license to a clubhouse
  async addClubLicense({ commit }, payload) {
    let response;

    commit(ADD_CLUB_LICENSE);

    try {
      response = await API.clubhouses.addLicense(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(ADD_CLUB_LICENSE_FAILED);
        reject(response);
      } else {
        commit(ADD_CLUB_LICENSE_SUCCESS, payload);

        // Return GET data within promise
        resolve(response.data);
      }
    });
  },

  // * get clubhouse coordinates (lat,lng)
  async getCoordinates({ commit }, payload) {
    commit(SET_CLUB_ADDRESS, payload);

    let response;

    try {
      response = await API.clubhouses.getCoordinates(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(UPDATE_CLUBHOUSE_FAILED);
        reject(response);
      } else {
        const defaultCenter = { lat: 40.915045, lng: -111.89068 };
        const location = response.data.results.length
          ? response.data.results[0].geometry.location
          : defaultCenter;
        commit(UPDATE_CLUBHOUSE_COORDS, location);

        // Return GET data within promise
        resolve(location);
      }
    });
  },

  // * set clubhouse member handicap
  async setHandicap({ commit }, payload) {
    let response;

    commit(SET_HANDICAP);

    try {
      response = await API.clubhouses.setHandicap(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(SET_HANDICAP_FAILED);
        reject(response);
        return;
      }

      commit(SET_HANDICAP_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * update clubmember
  async updateClubmember({ commit }, payload) {
    let response;

    commit(UPDATE_CLUBMEMBER);

    try {
      response = await API.clubhouses.updateClubmember(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(UPDATE_CLUBMEMBER_FAILED);
        reject(response);
        return;
      }

      commit(UPDATE_CLUBMEMBER_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get clubmember details
  async getClubmember({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.clubhouses.getClubmember(payload);

      if (!response?.data) {
        response.data = {};
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * create clubhouse card
  async createCard({ commit, dispatch }, payload) {
    let response = {};

    commit(CREATE_CLUBHOUSE_CARD);

    try {
      response = await API.clubhouses.createCard(payload);
    } catch (error) {
      response = error;
    }

    try {
      if (payload?.image?.file) {
        firebaseImageUpload(response, payload, 'announcement', payload.image).on(
          'state_changed',
          (snapshot) => {
            const progress = Math.floor((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            commit(SET_UPLOAD_PROGRESS, progress);
          }
        );
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(CREATE_CLUBHOUSE_CARD_FAILED);
        reject(response);
        return;
      }

      commit(CREATE_CLUBHOUSE_CARD_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * update clubhouse card
  async updateCard({ commit }, payload) {
    let response = {};

    commit(UPDATE_CLUBHOUSE_CARD);

    try {
      response = await API.clubhouses.updateCard(payload);
    } catch (error) {
      response = error;
    }

    if (payload.image.file) {
      try {
        firebaseImageUpload(response, payload, 'announcement', payload.image).on(
          'state_changed',
          (snapshot) => {
            const progress = Math.floor((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            commit(SET_UPLOAD_PROGRESS, progress);
          }
        );
      } catch (error) {
        response = error;
      }
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(UPDATE_CLUBHOUSE_CARD_FAILED);
        reject(response);
        return;
      }

      commit(UPDATE_CLUBHOUSE_CARD_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * show individual clubhouse card
  async showCard({ commit }, payload) {
    let response;

    commit(GET_CLUBHOUSE_CARD);

    try {
      response = await API.clubhouses.showCard(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUBHOUSE_CARD_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUBHOUSE_CARD_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * list all clubhouse cards
  async listCards({ commit }, payload) {
    let response;

    commit(GET_CLUBHOUSE_CARDS);

    try {
      response = await API.clubhouses.listCards(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUBHOUSE_CARDS_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUBHOUSE_CARDS_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * delete individual clubhouse card
  async deleteCard({ commit }, payload) {
    let response;

    commit(DELETE_CLUBHOUSE_CARD);

    try {
      response = await API.clubhouses.deleteCard(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(DELETE_CLUBHOUSE_CARD_FAILED);
        reject(response);
        return;
      }

      commit(DELETE_CLUBHOUSE_CARD_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * list all clubhouse cards for a user
  async listUserClubCards({ commit }, payload) {
    let response;
    let cards;

    commit(GET_USER_CLUBHOUSE_CARDS);

    const clubhouses = payload?.map((item) => {
      return item.id.toString();
    });

    try {
      if (!clubhouses.length) {
        cards = [];
      }
      cards = await Promise.all(
        clubhouses.map(async (club) => {
          const cardResponse = await API.clubhouses.listCards(club);
          if (cardResponse.data.length) {
            const clubhouse = [
              ...new Set(
                cardResponse.data.map((data) => {
                  return data.clubHouseID;
                })
              ),
            ];
            const clubResponse = await API.clubhouses.show(clubhouse?.[0].toString());

            if (!clubResponse.data) {
              return cardResponse.data;
            }

            const cardDetails = cardResponse.data.map((data) => {
              return {
                ...data,
                clubhouseName: clubResponse.data.name,
                clubhouseLogo: clubResponse.data.logoUrl,
              };
            });

            return cardDetails;
          }
          return cardResponse.data;
        })
      );

      cards = cards
        .filter((card) => {
          return card !== undefined;
        })
        .flat();
    } catch (error) {
      cards = error;
      response = error;
    }

    return new Promise((resolve, reject) => {
      // * don't reject cards as it will always return at least an empty []
      // if (!cards.length) {
      //   commit(GET_USER_CLUBHOUSE_CARDS_FAILED);
      //   reject(cards);
      // }

      commit(GET_USER_CLUBHOUSE_CARDS_SUCCESS, cards);
      resolve(cards);
    });
  },

  // * Delete individual clubhouse card image
  // @ Used for ALL image deleting in the drag and drop uploader
  async deleteImage({ commit }, payload) {
    const storageRef = firebase.storage().ref();
    commit(DELETE_CLUBHOUSE_IMAGE);

    if (payload.url) {
      const fullUrl = payload.url.split('/');
      const protocol = fullUrl[0];
      const host = fullUrl[2];
      let url = `${protocol}//${host}/`;
      url = payload.url.replace(url, '');
      payload.imagePath = url;

      try {
        const image = await storageRef.child(payload.imagePath);

        image
          .delete()
          .then(async () => {
            console.log('image deleted');
            commit(DELETE_CLUBHOUSE_IMAGE_SUCCESS);
          })
          .catch((err) => {
            console.error(err);
            commit(DELETE_CLUBHOUSE_IMAGE_FAILED);
          });
      } catch (error) {
        console.error('error:', error);
        commit(DELETE_CLUBHOUSE_IMAGE_FAILED);
      }
    }
  },

  // * preview clubhouse email
  async emailPreview({ commit }, payload) {
    // console.log('emailPreview payload:', payload);
    const EMAIL_IMG_DIRECTORY = 'uploads/clubhouses/email/';
    const key = `${payload.clubhouseID ? payload.clubhouseID : ''}`;
    let response = {};

    try {
      if ((!payload?.ImageURL || !payload?.imageUrl) && payload?.image?.file) {
        const folder = payload.clubhouseID;
        const imageName = payload?.image.file.name.split(' ').join('-');
        const filename = imageName.substr(0, imageName.indexOf('.'));
        const ext = imageName.slice(imageName.lastIndexOf('.'));
        const fileDir = EMAIL_IMG_DIRECTORY;

        const storageRef = firebase.storage().ref();
        const uploadTask = await storageRef
          .child(`${fileDir}${folder}/${filename}_${key}${ext}`)
          .put(payload.image.file);

        uploadTask.on(
          'state_changed',
          (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log(`Upload is ${progress}% done`);
            commit(SET_UPLOAD_PROGRESS, progress);
          },
          (error) => {
            // Handle unsuccessful uploads
            console.error('error:', error);
          },
          () => {
            // Handle successful uploads on complete
            uploadTask.snapshot.ref.getDownloadURL().then(async (downloadURL) => {
              response = await API.clubhouses.emailPreview(payload);
              return new Promise((resolve, reject) => {
                if (response.status >= 400 || response.status === 0) {
                  reject(response);
                }

                resolve(response.data);
              });
            });
          }
        );
      } else {
        response = await API.clubhouses.emailPreview(payload);

        return new Promise((resolve, reject) => {
          if (response.status >= 400 || response.status === 0) {
            reject(response);
          }

          resolve(response.data);
        });
      }
    } catch (error) {
      response = error;
    }
  },

  // * reset card state
  resetCard({ commit }) {
    commit(RESET_CARD);
  },

  // @ Clubhouse Global stats ==============================================

  // * get club user stats
  // @ clubID, fromDate, toDate are in payload
  async clubhouseUserStats({ commit }, payload) {
    let response;

    commit(GET_CLUB_USER_STATS);

    try {
      response = await API.clubhouses.clubhouseUserStats(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_USER_STATS_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_USER_STATS_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get club top users
  // @ clubID, fromDate, toDate are in payload
  async clubhouseTopUsers({ commit }, payload) {
    let response;

    commit(GET_CLUB_TOP_USERS);

    try {
      response = await API.clubhouses.clubhouseTopUsers(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_TOP_USERS_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_TOP_USERS_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get club shot stats
  // @ clubID, fromDate, toDate are in payload
  async clubhouseShotStats({ commit }, payload) {
    let response;

    commit(GET_CLUB_SHOT_STATS);

    try {
      response = await API.clubhouses.clubhouseShotStats(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_SHOT_STATS_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_SHOT_STATS_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get club course stats
  // @ clubID, fromDate, toDate are in payload
  async clubhouseCourseStats({ commit }, payload) {
    let response;

    commit(GET_CLUB_COURSE_STATS);

    try {
      response = await API.clubhouses.clubhouseCourseStats(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_COURSE_STATS_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_COURSE_STATS_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get global club favorites
  // @ clubID, fromDate, toDate are in payload
  async clubhouseFavorites({ commit }, payload) {
    let response;

    commit(GET_CLUB_FAVORITES);

    try {
      response = await API.clubhouses.clubhouseFavorites(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_FAVORITES_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_FAVORITES_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get global club event stats
  // @ clubID, fromDate, toDate are in payload
  async clubhouseEventStats({ commit }, payload) {
    let response;

    commit(GET_CLUB_EVENTS);

    try {
      response = await API.clubhouses.clubhouseEventStats(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_EVENTS_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_EVENTS_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get global club event user stats
  // @ clubID, fromDate, toDate are in payload
  async clubhouseEventUserStats({ commit }, payload) {
    let response;

    commit(GET_CLUB_EVENT_USERS);

    try {
      response = await API.clubhouses.clubhouseEventUserStats(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_EVENT_USERS_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_EVENT_USERS_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get global club game mode stats
  // @ clubID, fromDate, toDate are in payload
  async clubhouseGameModeStats({ commit }, payload) {
    let response;

    commit(GET_CLUB_GAME_MODES);

    try {
      response = await API.clubhouses.clubhouseGameModeStats(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_GAME_MODES_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_GAME_MODES_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get global club round stats
  // @ clubID, fromDate, toDate are in payload
  async clubhouseRoundStats({ commit }, payload) {
    let response;

    commit(GET_CLUB_ROUNDS);

    try {
      response = await API.clubhouses.clubhouseRoundStats(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_ROUNDS_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_ROUNDS_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get club usage stats for all licenses/sims
  // @ clubID, fromDate, toDate are in payload
  async clubhouseUsageStats({ commit }, payload) {
    let response;

    commit(GET_CLUB_USAGE_STATS);

    try {
      response = await API.clubhouses.clubhouseUsageStats(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_USAGE_STATS_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_USAGE_STATS_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // @ Clubhouse per sim stats ==============================================

  // * get per sim club users
  // @ clubID, licenseID, fromDate, toDate are in payload
  async clubhouseSimUsers({ commit }, payload) {
    let response;

    commit(GET_CLUB_SIM_USERS);

    try {
      response = await API.clubhouses.clubhouseSimUsers(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_SIM_USERS_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_SIM_USERS_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get per sim club top users
  // @ clubID, licenseID, fromDate, toDate are in payload
  async clubhouseSimTopUsers({ commit }, payload) {
    let response;

    commit(GET_CLUB_SIM_TOP_USERS);

    try {
      response = await API.clubhouses.clubhouseSimTopUsers(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_SIM_TOP_USERS_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_SIM_TOP_USERS_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get per sim club shots
  // @ clubID, licenseID, fromDate, toDate are in payload
  async clubhouseSimShots({ commit }, payload) {
    let response;

    commit(GET_CLUB_SIM_SHOTS);

    try {
      response = await API.clubhouses.clubhouseSimShots(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_SIM_SHOTS_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_SIM_SHOTS_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get per sim club courses
  // @ clubID, licenseID, fromDate, toDate are in payload
  async clubhouseSimCourses({ commit }, payload) {
    let response;

    commit(GET_CLUB_SIM_COURSES);

    try {
      response = await API.clubhouses.clubhouseSimCourses(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_SIM_COURSES_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_SIM_COURSES_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get per sim club favorites
  // @ clubID, licenseID, fromDate, toDate are in payload
  async clubhouseSimFavorites({ commit }, payload) {
    let response;

    commit(GET_CLUB_SIM_FAVORITES);

    try {
      response = await API.clubhouses.clubhouseSimFavorites(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_SIM_FAVORITES_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_SIM_FAVORITES_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get per sim club game modes
  // @ clubID, licenseID, fromDate, toDate are in payload
  async clubhouseSimGameModes({ commit }, payload) {
    let response;

    commit(GET_CLUB_SIM_GAME_MODES);

    try {
      response = await API.clubhouses.clubhouseSimGameModes(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_SIM_GAME_MODES_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_SIM_GAME_MODES_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get per sim club rounds
  // @ clubID, licenseID, fromDate, toDate, fromTime, toTime are in payload
  async clubhouseSimRounds({ commit }, payload) {
    let response;

    commit(GET_CLUB_SIM_ROUNDS);

    try {
      response = await API.clubhouses.clubhouseSimRounds(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_SIM_ROUNDS_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_SIM_ROUNDS_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * get per sim club usage
  // @ clubID, licenseID, fromDate, toDate are in payload
  async clubhouseSimUsage({ commit }, payload) {
    let response;

    commit(GET_CLUB_SIM_USAGE);

    try {
      response = await API.clubhouses.clubhouseSimUsage(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_CLUB_SIM_USAGE_FAILED);
        reject(response);
        return;
      }

      commit(GET_CLUB_SIM_USAGE_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * reset club stats state
  resetClubStats({ commit }) {
    commit(RESET_CLUB_STATS);
  },

  // * reset per sim club stats state
  resetClubSimStats({ commit }) {
    commit(RESET_CLUB_SIM_STATS);
  },

  // * reset club licenses state
  resetClubLicenses({ commit }) {
    commit(RESET_CLUB_LICENSES);
  },

  // * reset club members state
  resetClubMembers({ commit }) {
    commit(RESET_CLUB_MEMBERS);
  },
};

// clubhouseUserStats
// clubhouseTopUsers
// clubhouseShotStats

// Clubhouse mutations
const mutations = {
  [GET_CLUBHOUSES](state) {
    state.loading = true;
  },

  [GET_CLUBHOUSES_SUCCESS](state, clubhouses) {
    state.all = clubhouses;
    state.loading = false;
  },

  [GET_CLUBHOUSES_FAILED](state) {
    state.loading = false;
  },

  [GET_CLUBHOUSE](state) {
    state.loadingClubhouse = true;
  },

  [GET_CLUBHOUSE_SUCCESS](state, payload) {
    state.clubhouse = payload;
    state.loadingClubhouse = false;
  },

  [GET_CLUBHOUSE_FAILED](state) {
    state.loadingClubhouse = false;
  },

  [RESET_CLUBHOUSE](state) {
    state.clubhouse = {};
    state.loadingClubhouse = false;
  },

  [UPDATE_CLUBHOUSE](state) {
    state.loading = true;
  },

  [UPDATE_CLUBHOUSE_SUCCESS](state, payload) {
    state.clubhouse = payload;
    state.loading = false;
  },

  [UPDATE_CLUBHOUSE_FAILED](state) {
    state.loading = false;
  },

  [DELETE_CLUBHOUSE](state) {
    state.loading = true;
  },

  [DELETE_CLUBHOUSE_SUCCESS](state, clubID) {
    // state.all = state.all.filter((club) => club.id !== clubID);
    state.loading = false;
  },

  [DELETE_CLUBHOUSE_FAILED](state) {
    state.loading = false;
  },

  [SET_HANDICAP](state) {
    state.loading = true;
  },

  [SET_HANDICAP_SUCCESS](state, payload) {
    state.handicap = payload;
    state.loading = false;
  },

  [SET_HANDICAP_FAILED](state) {
    state.loading = false;
  },

  [CREATE_CLUBHOUSE_CARD](state) {
    state.loading = true;
  },

  [CREATE_CLUBHOUSE_CARD_SUCCESS](state, payload) {
    state.clubhouseCard = payload;
    state.loading = false;
  },

  [CREATE_CLUBHOUSE_CARD_FAILED](state) {
    state.loading = false;
  },

  [GET_CLUBHOUSE_CARD](state) {
    state.loading = true;
  },

  [GET_CLUBHOUSE_CARD_SUCCESS](state, payload) {
    state.clubhouseCard = payload;
    state.uploadProgress = 0;
    state.loading = false;
  },

  [GET_CLUBHOUSE_CARD_FAILED](state) {
    state.loading = false;
  },

  [DELETE_CLUBHOUSE_CARD](state) {
    state.loading = true;
  },

  [DELETE_CLUBHOUSE_CARD_SUCCESS](state, payload) {
    state.clubhouseCards = state.clubhouseCards.filter((card) => {
      return card.id !== payload.id;
    });
    state.uploadProgress = 0;
    state.loading = false;
  },

  [DELETE_CLUBHOUSE_CARD_FAILED](state) {
    state.loading = false;
  },

  [DELETE_CLUBHOUSE_IMAGE](state) {
    state.loading = true;
  },

  [DELETE_CLUBHOUSE_IMAGE_SUCCESS](state) {
    state.loading = false;
  },

  [DELETE_CLUBHOUSE_IMAGE_FAILED](state) {
    state.loading = false;
  },

  [GET_CLUBHOUSE_CARDS](state) {
    state.cardsLoading = true;
  },

  [GET_CLUBHOUSE_CARDS_SUCCESS](state, payload) {
    state.clubhouseCards = payload;
    state.cardsLoading = false;
  },

  [GET_CLUBHOUSE_CARDS_FAILED](state) {
    state.cardsLoading = false;
  },

  [GET_USER_CLUBHOUSE_CARDS](state) {
    state.userCardsLoading = true;
  },

  [GET_USER_CLUBHOUSE_CARDS_SUCCESS](state, data) {
    state.userClubhouseCards = data;
    state.userCardsLoading = false;
  },

  [GET_USER_CLUBHOUSE_CARDS_FAILED](state) {
    state.userCardsLoading = false;
  },

  [UPDATE_CLUBHOUSE_CARD](state) {
    state.loading = true;
  },

  [UPDATE_CLUBHOUSE_CARD_SUCCESS](state, payload) {
    state.clubhouseCard = payload;
    state.loading = false;
  },

  [UPDATE_CLUBHOUSE_CARD_FAILED](state) {
    state.loading = false;
  },

  [UPDATE_CLUBHOUSE_HOURS](state, payload) {
    state.clubhouse.hours = payload;
  },

  [UPDATE_CLUBHOUSE_COORDS](state, payload) {
    state.coordinates = payload;
    state.loading = false;
  },

  [RESET_CARD](state) {
    state.clubhouseCard = {};
  },

  [GET_MEMBERS](state) {
    state.loading = true;
  },

  [GET_MEMBERS_SUCCESS](state, members) {
    state.clubhouseMembers = members;
    state.loading = false;
  },

  [GET_MEMBERS_FAILED](state) {
    state.loading = false;
  },

  [GET_MEMBER_CLUBS](state) {
    state.loading = true;
  },

  [GET_MEMBER_CLUBS_SUCCESS](state, data) {
    state.memberClubs = data;
    state.loading = false;
  },

  [GET_MEMBER_CLUBS_FAILED](state) {
    state.loading = false;
  },

  [UPDATE_CLUBMEMBER](state) {
    state.loading = true;
  },

  [UPDATE_CLUBMEMBER_SUCCESS](state, data) {
    state.clubmember = data;
    state.loading = false;
  },

  [UPDATE_CLUBMEMBER_FAILED](state) {
    state.loading = false;
  },

  [DELETE_MEMBER](state) {
    state.loading = true;
  },

  [DELETE_MEMBER_SUCCESS](state, memberInfo) {
    state.clubhouseMembers = state.clubhouseMembers.filter((member) => {
      return member.user_uuid !== memberInfo.user_uuid;
    });
    state.loading = false;
  },

  [DELETE_MEMBER_FAILED](state) {
    state.loading = false;
  },

  [GET_LICENSES](state) {
    state.loadingLicenses = true;
  },

  [GET_LICENSES_SUCCESS](state, licenses) {
    state.licenses = licenses;
    state.loadingLicenses = false;
  },

  [GET_LICENSES_FAILED](state) {
    state.loadingLicenses = false;
  },

  [ADD_CLUB_LICENSE](state) {
    // state.loadingLicenses = true;
  },

  [ADD_CLUB_LICENSE_SUCCESS](state, license) {
    // state.licenses = licenses;
    // state.loadingLicenses = false;
  },

  [ADD_CLUB_LICENSE_FAILED](state) {
    // state.loadingLicenses = false;
  },

  [GET_ALL_LICENSES](state) {
    state.loadingAllLicenses = true;
  },

  [GET_ALL_LICENSES_SUCCESS](state, licenses) {
    state.allLicenses = licenses;
    state.loadingAllLicenses = false;
  },

  [GET_ALL_LICENSES_FAILED](state) {
    state.loadingAllLicenses = false;
  },

  [DELETE_LICENSE](state) {
    state.loading = true;
  },

  [DELETE_LICENSE_SUCCESS](state, licenseID) {
    state.licenses = state.licenses.filter((license) => {
      return license.id !== licenseID.id;
    });
    state.loading = false;
  },

  [DELETE_LICENSE_FAILED](state) {
    state.loading = false;
  },

  [SET_UPLOAD_PROGRESS](state, payload) {
    state.uploadProgress = payload;
  },

  [SET_CLUB_ADDRESS](state, payload) {
    state.clubhouseAddress = payload;
  },

  // @ Clubhouse Global stats ==============================================

  [GET_CLUB_USER_STATS](state) {
    state.loadingClubStats = true;
  },

  [GET_CLUB_USER_STATS_SUCCESS](state, data) {
    state.clubhouseUserStats = data;
    state.loadingClubStats = false;
  },

  [GET_CLUB_USER_STATS_FAILED](state) {
    state.loadingClubStats = false;
  },

  [GET_CLUB_TOP_USERS](state) {
    state.loadingClubTopUserStats = true;
  },

  [GET_CLUB_TOP_USERS_SUCCESS](state, data) {
    state.clubhouseTopUsers = data;
    state.loadingClubTopUserStats = false;
  },

  [GET_CLUB_TOP_USERS_FAILED](state) {
    state.loadingClubTopUserStats = false;
  },

  [GET_CLUB_SHOT_STATS](state) {
    state.loadingClubShotStats = true;
  },

  [GET_CLUB_SHOT_STATS_SUCCESS](state, data) {
    state.clubhouseShotStats = data;
    state.loadingClubShotStats = false;
  },

  [GET_CLUB_SHOT_STATS_FAILED](state) {
    state.loadingClubShotStats = false;
  },

  [GET_CLUB_COURSE_STATS](state) {
    state.loadingCourseStats = true;
  },

  [GET_CLUB_COURSE_STATS_SUCCESS](state, data) {
    state.clubhouseCourseStats = data;
    state.loadingCourseStats = false;
  },

  [GET_CLUB_COURSE_STATS_FAILED](state) {
    state.loadingCourseStats = false;
  },

  [GET_CLUB_FAVORITES](state) {
    state.loadingClubFavorites = true;
  },

  [GET_CLUB_FAVORITES_SUCCESS](state, data) {
    state.clubhouseFavorites = data;
    state.loadingClubFavorites = false;
  },

  [GET_CLUB_FAVORITES_FAILED](state) {
    state.loadingClubFavorites = false;
  },

  [GET_CLUB_EVENTS](state) {
    state.loadingClubEventStats = true;
  },

  [GET_CLUB_EVENTS_SUCCESS](state, data) {
    state.clubhouseEventStats = data;
    state.loadingClubEventStats = false;
  },

  [GET_CLUB_EVENTS_FAILED](state) {
    state.loadingClubEventStats = false;
  },

  [GET_CLUB_EVENT_USERS](state) {
    state.loadingClubEventUserStats = true;
  },

  [GET_CLUB_EVENT_USERS_SUCCESS](state, data) {
    state.clubhouseEventUserStats = data;
    state.loadingClubEventUserStats = false;
  },

  [GET_CLUB_EVENT_USERS_FAILED](state) {
    state.loadingClubEventUserStats = false;
  },

  [GET_CLUB_GAME_MODES](state) {
    state.loadingClubGameModeStats = true;
  },

  [GET_CLUB_GAME_MODES_SUCCESS](state, data) {
    state.clubhouseGameModeStats = data;
    state.loadingClubGameModeStats = false;
  },

  [GET_CLUB_GAME_MODES_FAILED](state) {
    state.loadingClubGameModeStats = false;
  },

  [GET_CLUB_ROUNDS](state) {
    state.loadingClubRoundStats = true;
  },

  [GET_CLUB_ROUNDS_SUCCESS](state, data) {
    state.clubhouseRoundStats = data;
    state.loadingClubRoundStats = false;
  },

  [GET_CLUB_ROUNDS_FAILED](state) {
    state.loadingClubRoundStats = false;
  },

  [GET_CLUB_USAGE_STATS](state) {
    state.loadingClubUsageStats = true;
  },

  [GET_CLUB_USAGE_STATS_SUCCESS](state, data) {
    state.clubhouseUsageStats = data;
    state.loadingClubUsageStats = false;
  },

  [GET_CLUB_USAGE_STATS_FAILED](state) {
    state.loadingClubUsageStats = false;
  },

  // @ Clubhouse per sim stats ==============================================

  // * per sim club users
  [GET_CLUB_SIM_USERS](state) {
    state.loadingClubSimUsers = true;
  },

  [GET_CLUB_SIM_USERS_SUCCESS](state, data) {
    state.clubhouseSimUsers = data;
    state.loadingClubSimUsers = false;
  },

  [GET_CLUB_SIM_USERS_FAILED](state) {
    state.loadingClubSimUsers = false;
  },

  // * per sim club top users
  [GET_CLUB_SIM_TOP_USERS](state) {
    state.loadingClubSimTopUsers = true;
  },

  [GET_CLUB_SIM_TOP_USERS_SUCCESS](state, data) {
    state.clubhouseSimTopUsers = data;
    state.loadingClubSimTopUsers = false;
  },

  [GET_CLUB_SIM_TOP_USERS_FAILED](state) {
    state.loadingClubSimTopUsers = false;
  },

  // * per sim club courses
  [GET_CLUB_SIM_COURSES](state) {
    state.loadingClubSimCourses = true;
  },

  [GET_CLUB_SIM_COURSES_SUCCESS](state, data) {
    state.clubhouseSimCourses = data;
    state.loadingClubSimCourses = false;
  },

  [GET_CLUB_SIM_COURSES_FAILED](state) {
    state.loadingClubSimCourses = false;
  },

  // * per sim club shots
  [GET_CLUB_SIM_SHOTS](state) {
    state.loadingClubSimShots = true;
  },

  [GET_CLUB_SIM_SHOTS_SUCCESS](state, data) {
    state.clubhouseSimShots = data;
    state.loadingClubSimShots = false;
  },

  [GET_CLUB_SIM_SHOTS_FAILED](state) {
    state.loadingClubSimShots = false;
  },

  // * per sim club favorites
  [GET_CLUB_SIM_FAVORITES](state) {
    state.loadingClubSimFavorites = true;
  },

  [GET_CLUB_SIM_FAVORITES_SUCCESS](state, data) {
    state.clubhouseSimFavorites = data;
    state.loadingClubSimFavorites = false;
  },

  [GET_CLUB_SIM_FAVORITES_FAILED](state) {
    state.loadingClubSimFavorites = false;
  },

  // * per sim club game modes
  [GET_CLUB_SIM_GAME_MODES](state) {
    state.loadingClubSimGameModes = true;
  },

  [GET_CLUB_SIM_GAME_MODES_SUCCESS](state, data = []) {
    state.clubhouseSimGameModes = data;
    state.loadingClubSimGameModes = false;
  },

  [GET_CLUB_SIM_GAME_MODES_FAILED](state) {
    state.loadingClubSimGameModes = false;
  },

  // * per sim club rounds
  [GET_CLUB_SIM_ROUNDS](state) {
    state.loadingClubSimRounds = true;
  },

  [GET_CLUB_SIM_ROUNDS_SUCCESS](state, data = []) {
    state.clubhouseSimRounds = data;
    state.loadingClubSimRounds = false;
  },

  [GET_CLUB_SIM_ROUNDS_FAILED](state) {
    state.loadingClubSimRounds = false;
  },

  // * per sim club usage
  [GET_CLUB_SIM_USAGE](state) {
    state.loadingClubSimUsage = true;
  },

  [GET_CLUB_SIM_USAGE_SUCCESS](state, data) {
    state.clubhouseSimUsage = data;
    state.loadingClubSimUsage = false;
  },

  [GET_CLUB_SIM_USAGE_FAILED](state) {
    state.loadingClubSimUsage = false;
  },

  // @ Generic mutation
  [GET_DATA](state) {
    state.loadingGen = true;
  },

  [GET_DATA_FAILED](state) {
    state.loadingGen = false;
  },

  [GET_DATA_SUCCESS](state, data) {
    state.loadingGen = false;
  },

  [RESET_CLUB_LICENSES](state) {
    state.loadingLicenses = false;
    state.licenses = [];
  },

  [RESET_CLUB_MEMBERS](state) {
    state.loading = false;
    state.clubhouseMembers = [];
  },

  [RESET_CLUB_SIM_STATS](state) {
    state.clubhouseSimUsers = {};
    state.clubhouseSimTopUsers = [];
    state.clubhouseSimShots = {};
    state.clubhouseSimCourses = [];
    state.clubhouseSimFavorites = {};
    state.clubhouseSimGameModes = [];
    state.clubhouseSimRounds = [];

    state.loadingClubSimUsers = false;
    state.loadingClubSimTopUsers = false;
    state.loadingClubSimShots = false;
    state.loadingClubSimCourses = false;
    state.loadingClubSimFavorites = false;
    state.loadingClubSimGameModes = false;
    state.loadingClubSimRounds = false;
  },

  [RESET_CLUB_STATS](state) {
    state.clubhouseUserStats = {};
    state.clubhouseTopUsers = [];
    state.clubhouseShotStats = {};
    state.clubhouseCourseStats = [];
    state.clubhouseFavorites = {};
    state.clubhouseEventStats = [];
    state.clubhouseGameModeStats = [];
    state.clubhouseRoundStats = [];

    state.loadingClubStats = false;
    state.loadingClubTopUserStats = false;
    state.loadingClubShotStats = false;
    state.loadingCourseStats = false;
    state.loadingClubFavorites = false;
    state.loadingClubEventStats = false;
    state.loadingClubGameModeStats = false;
    state.loadingClubRoundStats = false;

    state.clubhouseSimUsers = {};
    state.clubhouseSimTopUsers = [];
    state.clubhouseSimShots = {};
    state.clubhouseSimCourses = [];
    state.clubhouseSimFavorites = {};

    state.loadingClubSimUsers = false;
    state.loadingClubSimTopUsers = false;
    state.loadingClubSimShots = false;
    state.loadingClubSimCourses = false;
    state.loadingClubSimFavorites = false;
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
